module.exports = __webpack_public_path__ + "img/logonova.f97b5640.png";